/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { PageVersionTypeEnums } from '@/views_v2/new-redirect/types';
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

import { customerServicePhone } from '@/constant';
import platform from '@/shared/utils/platform';
import { pageFeatureConfig, riskTipsWisdomKeyEnum, buttonNameEnum } from '../../../config';
import RiskTips from '../../outRelease/component/risk-tips/RiskTisp';

import type { pageConfigType } from '../../../config';

import style from './index.module.scss';

@Component({ name: 'MarketPageForFlow' })
export default class MarketPageForFlow extends Vue {
  // 页面版本
  @Prop(String) readonly pageVersion!: PageVersionTypeEnums

    private advantageList = [
      { name: '息费透明', style: 'money' },
      { name: '快速授信', style: 'speed' },
      { name: '尽享优惠', style: 'advantage' },
    ]

    /** 风险提示文案 */
    private riskTips = '';

    private get currentConfig(): pageConfigType | undefined {
      return pageFeatureConfig.get(this.pageVersion);
    }

    /** 按钮文案 */
    private buttonText = buttonNameEnum.WITHDRAW;

    /** 是否显示浏览器下载样式 */
    private get shouldShowBrowserStyle(): boolean {
      return this.buttonText === buttonNameEnum.OPEN_BROWSER_DOWNLOAD;
    }

    private async mounted() {
      const riskTipsConfig = await Vue.prototype.$tangram.getConfigValue({
        moduleCode: 'financial',
        keyCode: this.currentConfig?.riskTipsConfigKey || riskTipsWisdomKeyEnum.VERSION_ONE,
      });
      const pageConfig = riskTipsConfig[this.pageVersion] || {};
      this.riskTips = pageConfig.riskTips || '';
    }

    private redirectApp() {
      /** 针对028版本 */
      if (this.pageVersion === PageVersionTypeEnums.BAI_XIN_DOWNLOAD_PAGE
        && (platform.isDouyinMini || platform.isWechatMini)) {
        // 微信小程序或抖音小程序：按钮文案变更
        this.buttonText = buttonNameEnum.OPEN_BROWSER_DOWNLOAD;
      } else {
        this.buttonText = buttonNameEnum.WITHDRAW;
      }
      this.$emit('redirectApp');
    }

    private render() {
      return (
      <div class={style['market-page']}>
          <div class={style['top-banner']}>
              <div class={style['top-img']}></div>
          </div>
          <div class={style['main-wrapper']}>
            <div class={[style['main-title']]}>
            <span class={[style.line, style.left]}/>
            <span class={style.text}>至高可借额度</span>
            <span class={[style.line, style.right]}/>
            </div>

            <div class={style['possible-num']}>
              200,000
              <span>元</span>
            </div>

            <div class={style['apply-tips']}>综合年化利率(单利)4.9%-24%</div>

            <div
              class={[
                style['apply-btn'],
                this.shouldShowBrowserStyle ? style['browser-btn'] : '',
              ]}
              onClick={this.redirectApp.bind(this)}
            >
              {this.buttonText}
            </div>
        </div>
        <div class={style['advantage-wrapper']}>
            {
            this.advantageList.map((item) => (
                <div class={style['advantage-item']}>
                    <span class={[style.icon, style[item.style]]}/>
                    <span>{item.name}</span>
                </div>
            ))
            }
        </div>

        {this.riskTips
          ? <RiskTips text={this.riskTips}/>
          : (
            <div>
              <div class={style['bottom-logo']}/>
              <div class={style['bottom-tips']}>
                <p>沪ICP备16050850号-19</p>
                <p>客服热线：{customerServicePhone}</p>
              </div>
            </div>
          )
        }
      </div>
      );
    }
}
